export default "__VITE_ASSET__xsWzj259__"